import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const widgets = require.context("./Widgets", true, /\.tsx$/);
// const onHotWidgetReplace = addWidgetsFromContext(widgets);
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);

// ensure HMR works for custom pages
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}
// Load all custom widgets so they are included in the bundle.
const widgets = require.context("./Widgets", true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
const onHotWidgetReplace = addWidgetsFromContext(widgets);

// Enable hot module reloading for custom widgets.
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

const extensions = require.context("./Extensions", true);
extensions.keys().forEach(key => extensions(key));

const utilities = require.context("./Utilities", true);
utilities.keys().forEach(key => utilities(key));

// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

setPreStyleGuideTheme({
    // specifies secondary colors are editable
    colors: {
        secondary: {
            main: "#0F0F0F",
        },
    },
});

setPostStyleGuideTheme({
    // specifies primary colors are not editable & fixed to these values
    typography: {
        fontFamilyImportUrl: "https://use.typekit.net/tbt3qei.css",
        body: {
            fontFamily: "proxima-nova !important",
        },
        headerPrimary: {
            fontFamily: "proxima-nova !important",
        },
        headerSecondary: {
            fontFamily: "proxima-nova !important",
            weight: 600,
        },
        headerTertiary: {
            fontFamily: "proxima-nova !important",
        },
        h2: {
            fontFamily: "proxima-nova !important",
        },
    },
    colors: {
        primary: {
            main: "#33333A",
        },
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                inputSelect: css`
                    font-size: 16px !important;
                `,
            },
        },
    },
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 720, 960, 1140],
    },
    shadows: {
        1: "0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)",
        2: "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        3: "inset -10px 0 10px 0 rgba(0,0,0,0.14)",
    },
    focus: {
        color: "transprent",
        style: "solid",
        width: "0px",
    },
    zIndex: {
        toaster: 9999,
    },
    toast: {
        defaultProps: {
            cssOverrides: {
                toast: css`
                    background: #fff;
                    border-color: #2e64b0;
                `,
                toastBody: css`
                    > span[class^="IconWrapper"] {
                        svg {
                            color: #2e64b0;
                        }
                    }
                `,
            },
        },
    },
    button: {
        primary: {
            shape: "rectangle",
            css: css `
                padding: 0 18px;
                background: #313639 !important;
                border: 1px solid #313639  !important;
                span[class^="TypographyStyle"] {
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    line-height: normal;
                    text-align: center;
                    color: #ffffff;
                    text-transform: uppercase;
                } 
                &:hover{
                    border: 1px solid #010B13 !important;
                    background: #010B13 !important;
                    span[class^="TypographyStyle"] {
                        color: #ffffff;
                    }
                }
                &:disabled {
                    background-color: #CCCCCC !important;
                    border-color: #CCCCCC !important;
                }
                `,
        },
        secondary: {
            shape: "rectangle",
            css: css`
            padding: 0 18px;
            background: #ffffff !important;
            border: 1px solid rgb(204, 204, 204) !important;
            span[class^="TypographyStyle"] {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: #000000;
                text-transform: uppercase;
            } 
            &:hover{
                border: 1px solid rgb(1, 11, 19) !important;
                span[class^="TypographyStyle"] {
                    color: rgb(0, 107, 192); 
                }
            }
      `,
        },
        tertiary: {
            shape: "rectangle",
            css: css`
            padding: 0 18px;
            background: #91ADCE !important;
            border: 1px solid #91ADCE  !important;
            span[class^="TypographyStyle"] {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: #ffffff;
                text-transform: uppercase;
            } 
            &:hover{
                border: 1px solid #688EB9 !important;
                background: #688EB9 !important;
                span[class^="TypographyStyle"] {
                    color: #ffffff;
                }
            }
      `,
        },
    },
});
